import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPrimaryContextDocument as GetPrimaryContextDocumentQuery,
    GetPrimaryContextDocument_primaryContextDocument as PrimaryContextDocument,
} from 'nutshell-graphql-types';

import GET_PRIMARY_CONTEXT_DOCUMENT from '../queries/get-primary-context-document.graphql';

export const useGetPrimaryContextDocument = (): {
    primaryContextDocument: PrimaryContextDocument | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetPrimaryContextDocumentQuery,
        Record<any, any>
    >(GET_PRIMARY_CONTEXT_DOCUMENT);

    return {
        primaryContextDocument: data && data.primaryContextDocument,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
